export default __webpack_public_path__ + "c982cf4e2d497988131ebd800fe53100.svg";